import { render, staticRenderFns } from "./SideTagsPlan.vue?vue&type=template&id=fc4c5e1a&scoped=true&"
import script from "./SideTagsPlan.vue?vue&type=script&lang=js&"
export * from "./SideTagsPlan.vue?vue&type=script&lang=js&"
import style0 from "./SideTagsPlan.vue?vue&type=style&index=0&id=fc4c5e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4c5e1a",
  null
  
)

export default component.exports